import React, { useState, useEffect } from "react";
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Inputs from '../Common/Inputs';
import Output from '../Common/Output';
import RandomContent from '../Components/RandomContent';
import { formatSql } from "../Conversion/SqlFormat";

const SQLFormatter = () => {
  const [inputData, setInputData] = useState('');
  const [outputData, setOutputData] = useState('');
  const [isError, setIsError] = useState(false);
  const [fontSize, setFontSize] = useState(14);
  const [inputLnCol, setInputLnCol] = useState({ line: 1, column: 1 });
  const [outputLnCol, setOutputLnCol] = useState({ line: 1, column: 1 });

  useEffect(() => {
    setInputData('');
    setOutputData('');
    setIsError(false);
  }, []);

  const handleFormat = () => {
    try {
      const formatted = formatSql(inputData);
      setOutputData(formatted);
      setIsError(false);
    } catch (error) {
      setOutputData("Error formatting SQL");
      setIsError(true);
    }
  };

  return (
    <>
      <div>
        <Header />

        <RandomContent />

        {/* Intro Section */}
        <div className="blog-area pb-20">
          <div className="container-block-fluid">
            <div className="row justify-content-center">
              <div className="full-col col-lg-12 col-md-12">
                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                  <div className="details">
                    <h4><a href="#">Format SQL</a></h4>
                    <p>
                      Simplify your SQL formatting tasks with Data Beautifier's Free SQL Formatter Online Tool. Our Best SQL Formatter Online Tool organizes and beautifies your SQL queries for better readability and structure. Designed for user convenience, the Simple SQL Formatter Tool requires no technical knowledge, making it ideal for developers and non-technical users alike. With the Easy SQL Formatter Tool, you can format your SQL queries in just a few clicks, ensuring clean and well-structured code every time. Accessible 24/7 and completely free, Data Beautifier is your go-to solution for effortless SQL formatting. Try it today and streamline your workflow!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Input / Button / Output Section */}
        <div className="blog-area pb-20">
          <div className="container-block-fluid">
            <div className="row justify-content-center">

              {/* Input Box */}
              <div className="full-col col-lg-5 col-md-5">
                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                  <div className="thumb">
                    <Inputs
                      value={inputData}
                      setValue={(val) => {
                        setInputData(val);
                        setIsError(false);
                      }}
                      fontSize={fontSize}
                      setFontSize={setFontSize}
                      isError={isError}
                      lineCol={inputLnCol}
                      setLineCol={setInputLnCol}
                      readOnly={false}
                      idPrefix="input"
                    />
                  </div>
                </div>
              </div>

              {/* Format Button */}
              <div
                className="w3-col m2"
                style={{
                  flex: 2,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <button
                  className="default-btn icon four"
                  onClick={handleFormat}
                  disabled={!inputData.trim()}
                >
                  <i className="ri-braces-line"></i>
                  Format SQL
                </button>
              </div>

              {/* Output Box */}
              <div className="full-col col-lg-5 col-md-5">
                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="1200">
                  <div className="thumb">
                    <Output
                      value={outputData}
                      lineCol={outputLnCol}
                      setLineCol={setOutputLnCol}
                      fontSize={fontSize}
                      setFontSize={setFontSize}
                      isError={isError}
                      readOnly={true}
                      idPrefix="output"
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default SQLFormatter;
